import { PopoverTriggerProps } from '@radix-ui/react-popover';
import {
	DesktopNavigationOption,
	NavigationCategory,
	NavigationState,
} from 'src/components/Navigation/types';
import Chevron from 'src/components/Icons/Chevron';
import { cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';
import { getIsMediaHover } from 'src/utils/browser';

interface Props extends WithClassName, PopoverTriggerProps {
	navCategory: NavigationCategory;
	navOption: DesktopNavigationOption;
	handleNavigation: NavigationState['handleNavigation'];
	isActive: boolean;
	isOpen?: boolean;
}

export default function DesktopNavButton({
	navCategory,
	navOption,
	handleNavigation,
	className,
	isActive,
	isOpen,
	onClick,
	...rest
}: Props) {
	const isStaticOption = navOption.type === 'staticOption';
	const label = navOption.categoryName;

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (isStaticOption) {
			handleNavigation(navOption.handler());
		}

		// If it's a category (dropdown trigger), but also navigates to a page on click,
		// only navigate if we're on a hover capable device. On non-hover capable devices,
		// the only way to open the dropdown is to click, so we don't want to also navigate.
		if (!isStaticOption && navOption.handler && getIsMediaHover()) {
			handleNavigation(navOption.handler());
		}

		onClick?.(e);
	};

	return (
		<button
			id={`desktop_navigation_category_${navCategory}`}
			data-testid={`nav-${navCategory}`}
			className={cm(
				'flex h-full items-center gap-x-xs px-md py-xs whitespace-nowrap',
				'bg-main-bg typo-t3 text-text-secondary capitalize select-none',
				isActive ? 'text-text-default' : 'hover:text-purple-link',
				className
			)}
			onClick={handleClick}
			{...rest}
		>
			{label}
			{!isStaticOption && (
				<Chevron direction={isOpen ? 'up' : 'down'} className="w-md" />
			)}
		</button>
	);
}
